export const getVodItemDetailsPageStyles = () => {
    const mainContainerStyle = {
        padding: '0 10px 20px 10px',
        position: 'relative',
        height: '100vh',
        top: '30px',
    }
    const contentStyles = {
        position: 'absolute',
        display: 'flex',
        gap: ' 40px',
        padding: '0 10px 10px 0px',
        height: '90%',
        width: '100%',
    }

    const spinnerContainerStyle = {
        minHeight: '70vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }

    return {
        spinnerContainerStyle,
        contentStyles,
        mainContainerStyle,
    }
}
